import Img1 from "./../../assets/images/domain/Home/img11.jpeg";
import Img2 from "./../../assets/images/domain/Home/img22.jpeg";
import Img3 from "./../../assets/images/domain/Home/img33.jpg";
import H1 from "./../../assets/images/domain/Handles/img1.jpg";
import H2 from "./../../assets/images/domain/Handles/img2.jpg";
import H3 from "./../../assets/images/domain/Handles/img3.jpg";
import H4 from "./../../assets/images/domain/Handles/img4.jpg";
import H5 from "./../../assets/images/domain/Handles/img5.jpg";
import H6 from "./../../assets/images/domain/Handles/img6.jpg";
import H7 from "./../../assets/images/domain/Handles/img7.jpg";
import Img11 from "../../assets/images/domain/Home/img1.jpeg";
import Img22 from "../../assets/images/domain/Home/img2.png";
import Img33 from "../../assets/images/domain/Home/img3.jpeg";
import Img44 from "../../assets/images/domain/Home/img4.jpeg";
import Img55 from "../../assets/images/domain/Home/img55.png";
import Img10 from "../../assets/images/domain/Home/img10.jpeg";
import Img20 from "../../assets/images/domain/Home/img20.jpeg";
import Img30 from "../../assets/images/domain/Home/img22.jpeg";

// New project images
import Group88 from "../../assets/images/domain/Home/Group 88.png";
import Group88Copy from "../../assets/images/domain/Home/Group 88 copy.png";
import Group91 from "../../assets/images/domain/Home/Group 91.png";
import Group91Copy from "../../assets/images/domain/Home/Group 91 copy.png";
import Group91Copy2 from "../../assets/images/domain/Home/Group 91 copy 2.png";
import Group92 from "../../assets/images/domain/Home/Group 92.png";
import Group92Copy from "../../assets/images/domain/Home/Group 92 copy.png";
import Group92Copy2 from "../../assets/images/domain/Home/Group 92 copy 2.png";
import Group94 from "../../assets/images/domain/Home/Group 94.png";
import Group94Copy from "../../assets/images/domain/Home/Group 94 copy.png";
import Group95 from "../../assets/images/domain/Home/Group 95.png";
import Group95Copy from "../../assets/images/domain/Home/Group 95 copy.png";
import Group96 from "../../assets/images/domain/Home/Group 96.png";
import Group96Copy from "../../assets/images/domain/Home/Group 96 copy.png";
import Group96Copy2 from "../../assets/images/domain/Home/Group 96 copy 2.png";
import Group97 from "../../assets/images/domain/Home/Group 97.png";
/*
בעל החברה הינו מהנדס שימור ויוצא מחלקת שימור בעיריית תל אביב יפו-\n
ובעל ניסיון של 12 שנה במבנים לשימור.\n
*/
export const navList = [
  {
    id: 1,
    image: Img1,
    title: "פרויקטים",
    description: `חברתנו הינה חברת ייצור חלונות עץ למבנים לשימור,\n
המותאמים למבנה לפי תכניות אדריכליות באיכות עץ מיוחדים ועמידים ביותר בתנאי מזג האוויר בארץ.\n
צביעת העץ תקנית ותואמת ללחות הקיימת בארץ.\n
  \n
כל העבודות מבוצעות בתאום עם אדריכל הפרויקט ומחלקת שימור לאישור כל הפרטים הכי קטנים במוצר,\n
כולל אישור ה- Shop drawing וחלון הדוגמה לפני התחלת הפרויקט.\n
  \n
  \n
  \n
    `,
  },
  {
    id: 2,
    image: Img2,
    title: "שדרות ירושלים 111",
    subTitle: "יפו",
    description: `הבניין נבנה ב- 1932 כבית מגורים עבור משפחת זיפטה,\n
משפחה ערבית נוצרית ותיקה ואמידה ביפו שנאלצה לעקור ללבנון ב- 1948.\n
  \n
הבית עבר לידי המדינה על פי חוק נכסי נפקדים, שימש כמשרד צבאי ובשנים האחרונות עמד נטוש.\n
  \n
לאחרונה הושב לקהילה הערבית לטובת בית הדין השרעי, הדתי מוסלמי של יפו.\n
  \n
הפרויקט כולל חיזוק היסודות הקיימים והנגשת המבנה-\n
עבודת השימור מייצגת את מאפייני המבנה האקלקטי שבעל השפעה אוריינטלית.\n
    
    `,
  },
  {
    id: 3,
    image: Img3,
    title: "פירזול",
    description: `הפרזול היינו החלק המשלים לאותנטיות ושלמות יופיו של החלון לשימור (חלון עץ).\n
    \n
האביזרים הנבחרים על ידי האדריכלים ובעלי המקצוע מהווים חלק אינטגראלי מהשלמות מראה החלון או הדלת שעוצבה במיוחד למראה האותנטי והעתיק של המבנה.\n
  \n
יש לתת דגש ותשומת לב רבה לבחירת הפרזול בחלון או בדלת מעץ מפני שדרוג האלמנט הינו מתבטא בסוג הידית והציריה של החלון.\n
    `,
  },
];

export const Handles = [
  {
    id: 1,
    img: H1,
    name: "ידית חלון אלומיניום",
  },
  {
    id: 2,
    img: H2,
    name: "כיסוי צירים סטנדרט",
  },
  {
    id: 3,
    img: H3,
    name: "ידית חלון פליז כפולה לקרמון פנימי",
  },
  {
    id: 4,
    img: H4,
    name: "ידית חלון סטנדרטית",
  },
  {
    id: 5,
    img: H5,
    name: "ידית פליז",
  },
  {
    id: 6,
    img: H6,
    name: "ידית חלון פליז לקרמון פנימי",
  },
  {
    id: 7,
    img: H7,
    name: "דגם צירים לשימור",
  },
];

export const HandlesToMobile = [
  {
    id: 1,
    img: H1,
    name: "ידית חלון אלומיניום",
  },
  {
    id: 2,
    img: H3,
    name: "ידית חלון פליז כפולה לקרמון פנימי",
  },
  {
    id: 3,
    img: H2,
    name: "כיסוי צירים סטנדרט",
  },
  {
    id: 6,
    img: H6,
    name: "ידית חלון פליז לקרמון פנימי",
  },
  {
    id: 4,
    img: H4,
    name: "ידית חלון סטנדרטית",
  },
  {
    id: 5,
    img: H5,
    name: "ידית פליז",
  },

  {
    id: 7,
    img: H7,
    name: "דגם צירים לשימור",
  },
];

export const SwiperDataMobile = [
  {
    id: 1,
    title: "שדרות ירושלים 111",
    subTitle: "יפו",
    image: Img11,
  },
  {
    id: 2,
    title: "זלינהוף 7",
    subTitle: "יפו",
    image: Img22,
  },
  {
    id: 3,
    title: "רוטמן 18",
    subTitle: "יפו",
    image: Img33,
  },
  {
    id: 1,
    title: " ",
    subTitle: "יפו",
    image: Img44,
  },
];
export const SwiperDataDefault = [
  {
    id: 3,
    title: "רוטמן 18",
    subTitle: "יפו",
    image: Img33,
  },
  {
    id: 2,
    title: "זלינהוף 7",
    subTitle: "יפו",
    image: Img10,
  },
  {
    id: 1,
    title: "שדרות ירושלים 111",
    subTitle: "יפו",
    image: Img11,
  },

  {
    id: 2,
    title: "זלינהוף 7",
    subTitle: "יפו",
    image: Img22,
  },
  {
    id: 2,
    title: "זלינהוף 7",
    subTitle: "יפו",
    image: Img55,
  },
  {
    id: 1,
    title: " ",
    subTitle: "יפו",
    image: Img44,
  },
];

export const SwiperData1 = [
  {
    id: 1,
    title: "בקרוב",
    image: Img44,
  },
  {
    id: 2,
    title: "בקרוב",
    image: Img20,
  },
  {
    id: 1,
    title: "שדרות ירושלים 111",
    subTitle: "יפו",
    image: Img30,
    privateLink: "/sderot",
  },
  {
    id: 4,
    image: Img33,
    title: "בקרוב",
  },
  {
    id: 5,
    image: Img10,
    title: "בקרוב",
  },
  {
    id: 6,
    image: Img11,
    title: "בקרוב",
  },
  // {
  //   id: 7,
  //   image: Img22,
  //   title: "בקרוב",
  // },
  // {
  //   id: 8,
  //   image: Img55,
  //   title: "בקרוב",
  // },
];
export const SwiperData1ToMobile = [
  {
    id: 1,
    title: "שדרות ירושלים 111",
    subTitle: "יפו",
    image: Img30,
    privateLink: "/sderot",
  },
  {
    id: 2,
    title: "בקרוב",
    image: Img20,
  },
  {
    id: 1,
    title: "בקרוב",
    image: Img44,
  },
  {
    id: 4,
    image: Img33,
    title: "בקרוב",
  },
  {
    id: 5,
    image: Img10,
    title: "בקרוב",
  },
  {
    id: 6,
    image: Img11,
    title: "בקרוב",
  },
  // {
  //   id: 7,
  //   image: Img22,
  //   title: "בקרוב",
  // },
  // {
  //   id: 8,
  //   image: Img55,
  //   title: "בקרוב",
  // },
];
export const SwiperData2 = [
  {
    id: 1,
    image: Img44,
  },
  {
    id: 2,
    image: Img20,
  },
  {
    id: 3,
    image: Img30,
  },
  {
    id: 4,
    image: Img33,
  },
  {
    id: 5,
    image: Img10,
  },
  {
    id: 6,
    image: Img11,
  },
  // {
  //   id: 7,
  //   image: Img22,
  // },
  // {
  //   id: 8,
  //   image: Img55,
  // },
];
export const SwiperData2ToMobile = [
  {
    id: 3,
    image: Img30,
  },
  {
    id: 2,
    image: Img20,
  },
  {
    id: 1,
    image: Img44,
  },
  {
    id: 4,
    image: Img33,
  },
  {
    id: 5,
    image: Img10,
  },
  {
    id: 6,
    image: Img11,
  },
  // {
  //   id: 7,
  //   image: Img22,
  // },
  // {
  //   id: 8,
  //   image: Img55,
  // },
];

// New project detail pages data
export const newProjectsList = [
  {
    id: 4,
    image: Group91,
    title: "רוטשילד 101",
    subTitle: "תל אביב",
    description: `הבניין נבנה בשנות ה-30 בסגנון הבינלאומי האופייני לתל אביב,\n
כחלק מהעיר הלבנה שהוכרזה כאתר מורשת עולמית של אונסק"ו.\n
  \n
הפרויקט כלל שימור ושיקום מלא של חזיתות הבניין,\n
החלפת חלונות העץ המקוריים בחלונות עץ חדשים בהתאם לדרישות השימור,\n
תוך שמירה על הפרופורציות והעיצוב המקורי.\n
  \n
העבודה בוצעה בתיאום מלא עם מחלקת השימור של עיריית תל אביב-יפו.
    `,
    link: "/rotschild101",
  },
  {
    id: 5,
    image: Group92,
    title: "גורדון 82",
    subTitle: "תל אביב",
    description: `בניין מגורים ייחודי בסגנון מודרניסטי עם מרפסות מעוגלות אופייניות,\n
הממוקם ברחוב גורדון בלב תל אביב.\n
  \n
הפרויקט כלל שיפוץ כללי של המבנה תוך שימור האלמנטים האדריכליים הייחודיים,\n
והתקנת חלונות עץ חדשים המשתלבים עם האופי המקורי של הבניין.\n
  \n
החלונות יוצרו בהתאמה אישית לצורת המרפסות המעוגלות,\n
תוך שימוש בעץ איכותי העמיד בתנאי האקלים הישראלי.
    `,
    link: "/gordon82",
  },
  {
    id: 6,
    image: Group95,
    title: "הירשנברג 5",
    subTitle: "תל אביב",
    description: `בניין פינתי בסגנון באוהאוס קלאסי הממוקם בשכונת לב העיר,\n
עם חזיתות לבנות אופייניות ומרפסות מעוגלות.\n
  \n
במסגרת פרויקט השימור בוצעה החלפה מלאה של כל חלונות הבניין,\n
תוך שחזור מדויק של הפרופילים המקוריים והחלוקה ההיסטורית.\n
  \n
הצביעה בוצעה בהתאם לתקני השימור,\n
עם שימוש בחומרים מותאמים לאקלים הים תיכוני.
    `,
    link: "/hirshenberg5",
  },
];

// Completed projects gallery data (פרויקטים מוכנים)
export const completedProjectsData = [
  {
    id: 1,
    image: Group96,
    title: "רוטשילד 4",
    location: "תל אביב",
  },
  {
    id: 2,
    image: Group91,
    title: "גורדון 82",
    location: "תל אביב",
  },
  {
    id: 3,
    image: Group92Copy2,
    title: "הנשיא הראשון 65",
    location: "רחובות",
  },
  {
    id: 4,
    image: Group95,
    title: "רנק 11",
    location: "תל אביב",
  },
  {
    id: 5,
    image: Group96Copy,
    title: "הירשנברג 5",
    location: "תל אביב",
  },
  {
    id: 6,
    image: Img2,
    title: "רוטשילד 101",
    location: "תל אביב",
  },
];

// Projects under construction gallery data (פרויקטים בבניה)
export const underConstructionProjectsData = [
  {
    id: 1,
    image: Group91Copy,
    title: "יריחו 2-4",
    location: "תל אביב",
  },
  {
    id: 2,
    image: Group92Copy,
    title: "אידלסון 13",
    location: "תל אביב",
  },
  {
    id: 3,
    image: Group95Copy,
    title: "נחלת בנימין 23א",
    location: "תל אביב",
  },
  {
    id: 4,
    image: Group96Copy2,
    title: "פינסקר 5",
    location: "תל אביב",
  },
  {
    id: 5,
    image: Group91Copy2,
    title: "רמב״ם 17",
    location: "תל אביב",
  },
  {
    id: 6,
    image: Group92,
    title: "רוטשילד 87",
    location: "תל אביב",
  },
];

// Keep old export for backwards compatibility
export const projectsGalleryData = completedProjectsData;

// Swiper data for new project pages
export const SwiperDataRotschild = [
  { id: 1, image: Group91 },
  { id: 2, image: Group91Copy },
  { id: 3, image: Group91Copy2 },
  { id: 4, image: Group96 },
  { id: 5, image: Group96Copy },
];

export const SwiperDataRotschildMobile = [
  { id: 1, image: Group91 },
  { id: 2, image: Group91Copy },
  { id: 3, image: Group91Copy2 },
];

export const SwiperDataGordon = [
  { id: 1, image: Group92 },
  { id: 2, image: Group92Copy },
  { id: 3, image: Group92Copy2 },
  { id: 4, image: Group96Copy2 },
  { id: 5, image: Group95 },
];

export const SwiperDataGordonMobile = [
  { id: 1, image: Group92 },
  { id: 2, image: Group92Copy },
  { id: 3, image: Group92Copy2 },
];

export const SwiperDataHirshenberg = [
  { id: 1, image: Group95 },
  { id: 2, image: Group95Copy },
  { id: 3, image: Group96 },
  { id: 4, image: Group96Copy },
  { id: 5, image: Group91 },
];

export const SwiperDataHirshenbergMobile = [
  { id: 1, image: Group95 },
  { id: 2, image: Group95Copy },
  { id: 3, image: Group96 },
];

// Page 1 - Projects Gallery (6 unique images)
export const projectsPage1Data = [
  {
    id: 1,
    image: Group88,
    title: "בית הבד-שרונה",
    location: "תל אביב",
  },
  {
    id: 2,
    image: Group91,
    title: "בלפור 44",
    location: "תל אביב",
  },
  {
    id: 3,
    image: Group92,
    title: "הירקון 181",
    location: "תל אביב",
  },
  {
    id: 4,
    image: Group94,
    title: "מתחם התחנה",
    location: "תל אביב",
  },
  {
    id: 5,
    image: Group95,
    title: "רוחמה 16",
    location: "תל אביב",
  },
  {
    id: 6,
    image: Group96,
    title: "נחלת בנימין 7",
    location: "תל אביב",
  },
];

// Page 2 - Projects Gallery (8 images, 4 columns)
export const projectsPage2Data = [
  {
    id: 1,
    image: Group88Copy,
    title: "יריחו 2-4",
    location: "תל אביב",
  },
  {
    id: 2,
    image: Group91Copy,
    title: "אידלסון 13",
    location: "תל אביב",
  },
  {
    id: 3,
    image: Group92Copy,
    title: "נחלת בנימין 23א",
    location: "תל אביב",
  },
  {
    id: 4,
    image: Group94Copy,
    title: "פינסקר 5",
    location: "תל אביב",
  },
  {
    id: 5,
    image: Group95Copy,
    title: "רמב״ם 17",
    location: "תל אביב",
  },
  {
    id: 6,
    image: Group96Copy,
    title: "ביאליק 11",
    location: "תל אביב",
  },
  {
    id: 7,
    image: Group96Copy2,
    title: "רוטשילד 87",
    location: "תל אביב",
  },
  {
    id: 8,
    image: Group91Copy2,
    title: "גורדון 66",
    location: "תל אביב",
  },
];

// Page 3 - Projects Gallery (6 different unique images)
export const projectsPage3Data = [
  {
    id: 1,
    image: Group96Copy2,
    title: "רוטשילד 4",
    location: "תל אביב",
  },
  {
    id: 2,
    image: Group91Copy2,
    title: "גורדון 82",
    location: "תל אביב",
  },
  {
    id: 3,
    image: Group92Copy2,
    title: "הנשיא הראשון 65",
    location: "רחובות",
  },
  {
    id: 4,
    image: Group95,
    title: "רנק 11",
    location: "תל אביב",
  },
  {
    id: 5,
    image: Group94Copy,
    title: "הירשנברג 5",
    location: "תל אביב",
  },
  {
    id: 6,
    image: Group97,
    title: "רוטשילד 101",
    location: "תל אביב",
  },
];
